import React from "react";

// components
import Link from "../Link";

// assets
import styles from "@/assets/styles/components/tooltip-campaign-list.module.scss";


interface TooltipCampaign {
  id: number;
  name: string;
}

interface ITooltipCampaignListContent {
  campaigns: number[];
  campaignsNames: string[];
  isShowOnlyOnDesktop?: boolean;
  children?: React.ReactNode;
}

const TooltipCampaignListContent = ({ campaigns = [], campaignsNames = [] }: ITooltipCampaignListContent) => {
  const campaignsList: TooltipCampaign[] = [];
  campaigns.forEach((item, index) => {
    if (campaignsNames[index]) {
      campaignsList.push({
        name: campaignsNames[index],
        id: item,
      });
    }
  });

  return (
    <div className={styles["locl-tooltip-campaign-list__block"]} data-testid="locl-tooltip-campaign-list-content">
      <span>Added to</span>
      <ul className={styles["locl-tooltip-campaign-list__ul"]}>
        {
          campaignsList.map(item => (
            <li
              className={styles["locl-tooltip-campaign-list__li"]}
              data-testid="locl-tooltip-campaign-list-item"
              key={item.id}
            >
              <Link
                href={`/campaign/${item.id}/planner`}
                className={styles["locl-tooltip-campaign-list__link"]}
              >
                {item.name}
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

export default TooltipCampaignListContent;
